
/**
 * Shopify defines a global object that we can attempt to extract the customer id from.
 */
export function getShopifyCustomerId(): string|undefined {
  const __st = window.__st;
  return ("undefined" !== typeof __st && __st.cid) ? __st.cid.toString() : undefined;
}
